import pageStyle from "./index.module.less";
import List from "@/components/ticket/list";
import Detail from "@/components/ticket/detail";
import Creator from "@/components/ticket/creator";
import Reply from "./components/reply";
import * as service from "../service";
export default {
    name: "TicketTodo",
    components: { Creator, List, Detail, Reply },
    data() {
        return {
            loading: false,
            baseQuery: { action: "todo" },
            detail: undefined,
            pageStyle
        };
    },
    computed: {
        hasResult() {
            return this.detail.status >= 2;
        },
        canReply() {
            const { agent_id } = this.detail || {};
            return !this.hasResult && this.$store.state.ticket.me.id === agent_id;
        }
    },
    methods: {
        refresh(newDetail) {
            if (newDetail) {
                this.detail = newDetail;
            }
            this.$refs.list.query();
        },
        handleClick(data) {
            this.detail = data;
        },
        async toggleStatus() {
            this.loading = true;
            try {
                await service.updateMyStatus(this.$store.state.ticket.me.status ? 0 : 1);
                this.$store.dispatch("ticket/updateStatus");
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        async handleReplySubmit(input) {
            this.loading = true;
            try {
                const { id } = this.detail;
                const { result, answer } = input;
                await service.update([id], input);
                this.$notify({ message: this.$i18n.t("ticket.page.todo.reply_success"), type: "success" });
                const dealed_at = +new Date();
                this.refresh({ ...this.detail, result, answer, dealed_at, status: 2 });
                this.loading = false;
            } catch (err) {
                this.loading = false;
                throw err;
            }
        }
    }
};
